import React from 'react';
import '../../css/spinner.css';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/api-field-leazard-cloud'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({...dependencies, ...props})
  };

  return {
    html,
    config: {
      behaviour: 'text-input',
    },
  };
}
